import Vue from 'vue';
import flexTable from 'tm-flextable';

import 'tm-flextable/src/css/main.less';

Vue.use(flexTable);
